var replaceTitle = function replaceTitle(text) {
  var productTitle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return text.replace('{{product.title}}', productTitle);
};
export default replaceTitle;